export const ACCOUNT_ENTITY_TYPES = [
  {
    value: 0,
    label: 'Corporation',
  },
  {
    value: 1,
    label: 'Government',
  },
  {
    value: 2,
    label: 'LLC',
  },
  {
    value: 3,
    label: 'Non-Profit',
  },
  {
    value: 4,
    label: 'Other',
  },
  {
    value: 5,
    label: 'Partnership',
  },
  {
    value: 6,
    label: 'Private Utility',
  },
  {
    value: 7,
    label: 'Public Utility',
  },
  {
    value: 8,
    label: 'Sole Proprietor',
  },
];
